module.exports = __webpack_public_path__ + "static/media/brand-logo-green.59b29dcf.svg";